<svg
  fill="#000000"
  width="100%"
  height="100%"
  viewBox="0 0 64 64"
  xmlns="http://www.w3.org/2000/svg"
  focusable="false"
  aria-hidden="true"
  fill-rule="evenodd"
  clip-rule="evenodd"
  stroke-linejoin="round"
  stroke-miterlimit="2"
>
  <path
    d="M15.665,29.949l7.413,-7.413l-2.832,-2.833l-12.246,12.247l0.001,0.001l-0.001,0.001l12.246,12.246l2.832,-2.832l-7.411,-7.412l40.335,0l0,-4.005l-40.337,0Z"
  />
  <path
    d="M15.665,29.949l7.413,-7.413l-2.832,-2.833l-12.246,12.247l0,0.002l12.246,12.246l2.832,-2.832l-7.411,-7.412l40.335,0l0,-4.005l-40.337,0Zm4.585,-7.413l-0.004,-0.004l-9.418,9.418l0,0.002l9.418,9.418l0.004,-0.004l-5.997,-5.997l1.414,-3.415l38.335,0l0,-0.005l-38.337,0l-1.414,-3.414l5.999,-5.999Z"
  />
</svg>
